import { BasePayloadMapper } from '@ps/utils';
import {
  CompanyBuyerConfigBulkSavePayloadDto,
  CompanyBuyerCountrySettingsRequestDto,
} from '../dtos/company-buyer-config.dto';
import {
  BuyerConfigSettingsSavePayload,
  BuyerCountrySettingsSavePayload,
} from '../../models/company-buyer-config.model';

export class CompanyBuyerConfigPayloadMapper extends BasePayloadMapper<
  BuyerConfigSettingsSavePayload,
  CompanyBuyerConfigBulkSavePayloadDto
> {
  public toPayload(
    payload: BuyerConfigSettingsSavePayload,
  ): CompanyBuyerConfigBulkSavePayloadDto {
    return {
      id: payload.buyerId,
      changes: payload.changes.map((change) => ({
        config: change.config,
        enable: change.enable,
      })),
    };
  }

  public toCountrySettingsPayload(
    payload: BuyerCountrySettingsSavePayload,
  ): CompanyBuyerCountrySettingsRequestDto {
    return {
      cmp: payload.buyerId,
      ...(payload.defaultCountry !== undefined
        ? { default_country: payload.defaultCountry }
        : {}),
      ...(payload.blockedCountries !== undefined
        ? { blocked_countries: [...payload.blockedCountries] }
        : {}),
    };
  }
}
